import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomeView.vue'
import Sobre from '../views/SobreView.vue'
import Blog from '../views/BlogView.vue'
import BlogDetalhe from '../views/BlogDetalheView.vue'
import Contato from '../views/ContatoView.vue'
import Informacoes from '../views/InformacoesView.vue'
import ServicosDetalhe from '../views/ServicosDetalheView.vue'


const routes = [
 { path: '/', name: 'Home', component: Home },
 { path: '/sobre', name: 'Sobre', component: Sobre },
 { path: '/blog', name: 'Blog', component: Blog },
 { path: '/blogdetalhe/:id/:nome', name: 'BlogDetalhe', component: BlogDetalhe },
 { path: '/informacoes/:id/:nome', name: 'Informacoes', component: Informacoes },
 { path: '/servicosdetalhe/:id/:nome', name: 'ServicosDetalhe', component: ServicosDetalhe },
 { path: '/contato', name: 'Contato', component: Contato },
 
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
  next()
})

export default router